var React = require('react');

function Saved (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(23087 21132)"},[React.createElement("path",{"d":"M5.25,2.25h13.5V21.545L12,16.232,5.25,21.545Z","transform":"translate(-23088.25 -21132.898)","fill":"#bdff3b","fillRule":"evenodd","key":0}),React.createElement("rect",{"width":"22","height":"22","transform":"translate(-23087 -21132)","fill":"none","key":1})]));
}

Saved.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Saved;

Saved.default = Saved;
